import { Shield } from 'lucide-react'

type PageMetricsToolbarProps = {
  adminMode: boolean
  canToggleAdminMode: boolean
  onToggleAdminMode?: () => void
}

export function PageMetricsToolbar({
  adminMode,
  canToggleAdminMode,
  onToggleAdminMode,
}: PageMetricsToolbarProps) {
  if (!canToggleAdminMode || !onToggleAdminMode) return null

  return (
    <div className="flex items-center justify-end">
      <button
        type="button"
        onClick={onToggleAdminMode}
        aria-pressed={adminMode}
        className="flex items-center gap-1.5 text-xs font-medium text-fg-secondary transition-colors hover:text-fg"
      >
        <Shield size={14} fill={adminMode ? 'currentColor' : 'none'} />
        {adminMode ? 'Reader Mode' : 'Admin Mode'}
      </button>
    </div>
  )
}